<form #composerForm class="tt-ai-chat-composer" (submit)="onFormSubmit($event)">
    <label class="tt-ai-chat-composer__prompt-label" for="ai-chat-prompt" ttTranslateWord="prompt"></label>
    <kendo-editor
        #editor
        id="ai-chat-prompt"
        class="tt-ai-chat-composer__editor"
        [placeholder]="promptPlaceholder"
        [iframe]="false"
        [value]="prompt"
        [readonly]="loading || uploadingImages || sending"
        (valueChange)="setPrompt($event)"
        (paste)="onPaste($event)"
    >
        <kendo-toolbar class="k-toolbar-solid" [overflow]="false">
            <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>

            <kendo-toolbar-separator></kendo-toolbar-separator>

            <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>

            <kendo-toolbar-separator></kendo-toolbar-separator>

            <kendo-toolbar-button
                title="AI model"
                [text]="selectedModelName"
                iconClass="fal fa-chevron-down"
                class="tt-ai-chat-composer__model-trigger"
                className="tt-ai-chat-composer__model-button"
                [disabled]="loading || sending || models.length === 0"
                (click)="toggleModelMenu($event)"
            ></kendo-toolbar-button>

            <kendo-toolbar-button
                *ngIf="intelligenceLevels.length > 1"
                title="Intelligence level"
                [text]="selectedIntelligenceLevelName"
                iconClass="fal fa-chevron-down"
                class="tt-ai-chat-composer__intelligence-trigger"
                className="tt-ai-chat-composer__intelligence-button"
                [disabled]="loading || loadingIntelligenceLevels || sending"
                (click)="toggleIntelligenceMenu($event)"
            ></kendo-toolbar-button>

            <kendo-toolbar-spacer></kendo-toolbar-spacer>

            <kendo-toolbar-button
                title="Send prompt"
                text="Send"
                showText="overflow"
                themeColor="primary"
                className="tt-ai-chat-composer__send"
                [svgIcon]="sendIcon"
                [disabled]="!canSend"
                (click)="send()"
            ></kendo-toolbar-button>
        </kendo-toolbar>
    </kendo-editor>

    <div
        *ngIf="modelMenuOpen"
        class="tt-ai-chat-composer__model-menu"
        role="dialog"
        aria-label="AI model"
        [style.left.px]="modelMenuLeft"
        [style.bottom.px]="modelMenuBottom"
        [style.width.px]="modelMenuWidth"
        [style.max-height.px]="modelMenuMaxHeight"
    >
        <kendo-treeview
            [nodes]="modelTree"
            textField="text"
            kendoTreeViewHierarchyBinding
            childrenField="children"
            kendoTreeViewExpandable
            expandBy="id"
            [(expandedKeys)]="expandedProviderKeys"
            [kendoTreeViewSelectable]="'single'"
            selectBy="id"
            [selectedKeys]="selectedTreeKeys"
            [isDisabled]="isProviderNode"
            [disableParentNodesOnly]="true"
            [expandDisabledNodes]="true"
            [navigable]="true"
            (selectionChange)="selectTreeModel($event)"
        ></kendo-treeview>
    </div>

    <div
        *ngIf="intelligenceMenuOpen"
        class="tt-ai-chat-composer__intelligence-menu"
        role="listbox"
        aria-label="Intelligence level"
        [style.left.px]="intelligenceMenuLeft"
        [style.bottom.px]="intelligenceMenuBottom"
        [style.width.px]="intelligenceMenuWidth"
        [style.max-height.px]="intelligenceMenuMaxHeight"
    >
        <button
            *ngFor="let level of intelligenceLevels"
            type="button"
            class="tt-ai-chat-composer__intelligence-option"
            role="option"
            [class.tt-ai-chat-composer__intelligence-option--selected]="level.intelligence_level_id === selectedIntelligenceLevel"
            [attr.aria-selected]="level.intelligence_level_id === selectedIntelligenceLevel"
            [disabled]="loadingIntelligenceLevels"
            (click)="selectIntelligenceLevel(level)"
        >
            {{ level.intelligence_level_name }}
        </button>
    </div>
</form>
